import { useQuery, useMutation, invalidateKeys } from '../lib/query';

// Shared query + mutation hooks for the coordinate-moderation resources
// (hotels, restaurants) that expose the same list/bulk shape.
export function makeGeoHooks(key, { list, bulk }) {
  const useList = (params) =>
    useQuery({ queryKey: [key, params], queryFn: () => list(params) });

  const useBulk = (opts = {}) =>
    useMutation({
      mutationFn: (items) => bulk(items),
      onSuccess: (data, vars) => { invalidateKeys([key]); opts.onSuccess?.(data, vars); },
      onError: opts.onError,
    });

  return { useList, useBulk };
}
